import type { AuthDiscoverResponse } from '@/features/authentication/api/authApi';

export const getDashboardPath = (role: string) =>
  role === 'SERVICE_PROVIDER' ? '/dashboard/service-provider' : '/dashboard';

export const getDiscoveryStepCopy = (discoveryResult: AuthDiscoverResponse | null) => {
  const showOtpAction = Boolean(discoveryResult?.allowOtp);
  const showSsoAction = Boolean(discoveryResult?.authMethods.includes('sso'));

  if (showSsoAction && !showOtpAction && discoveryResult?.companyName) {
    return {
      title: `Continue with ${discoveryResult.companyName}`,
      description: 'Use your company sign-in to continue.',
    };
  }

  if (showSsoAction && showOtpAction) {
    return {
      title: 'Choose a sign-in method',
      description: 'Use SSO or email code.',
    };
  }

  if (showOtpAction && discoveryResult?.companyName) {
    return {
      title: `Continue with ${discoveryResult.companyName}`,
      description: 'We matched your company. Continue with email code.',
    };
  }

  return {
    title: 'Continue with email',
    description: 'Use the sign-in method we selected for you.',
  };
};
